// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={48}
    height={48}
    viewBox="0 0 48 48"
    {...props}
  >
    <circle
      cx={24}
      cy={24}
      r={23.5}
      fill="white"
      stroke="#CECEDC"
    />
    <g clipPath="url(#clip0_1847_114243)">
      <path
        d="M30.2687 35.7301H11.7812C11.4625 35.7301 11.25 35.5261 11.25 35.2201V22.9801C11.25 22.7761 11.3562 22.6231 11.5687 22.5211L23.6812 17.2681C23.7875 17.2171 23.9469 17.2171 24.0531 17.2681L30.4281 19.4101C30.6406 19.4611 30.8 19.6651 30.8 19.8691V35.2201C30.8 35.5261 30.5875 35.7301 30.2687 35.7301ZM12.3125 34.7101H29.7375V20.2261L23.8937 18.2881L12.3125 23.2861V34.7101Z"
        fill="#CECEDC"
      />
      <path
        d="M23.8406 35.73C23.5219 35.73 23.3094 35.526 23.3094 35.22V18.135C23.3094 17.829 23.5219 17.625 23.8406 17.625C24.1594 17.625 24.3719 17.829 24.3719 18.135V35.22C24.3719 35.526 24.1594 35.73 23.8406 35.73Z"
        fill="#CECEDC"
      />
      <path
        d="M13.6406 25.53C13.4281 25.53 13.2156 25.377 13.1094 25.173C13.0031 24.918 13.1625 24.612 13.4813 24.51L21.025 22.266C21.2906 22.164 21.6094 22.317 21.7156 22.623C21.8219 22.878 21.6625 23.184 21.3438 23.286L13.8 25.53C13.7469 25.53 13.6938 25.53 13.6406 25.53Z"
        fill="#CECEDC"
      />
      <path
        d="M13.6397 28.2329C13.3741 28.2329 13.1616 28.0799 13.1085 27.8249C13.0553 27.5699 13.2147 27.2639 13.5335 27.2129L21.0772 25.6829C21.3428 25.6319 21.6616 25.7849 21.7147 26.0909C21.7678 26.3459 21.6085 26.6519 21.2897 26.7029L13.746 28.2329C13.6928 28.2329 13.6928 28.2329 13.6397 28.2329Z"
        fill="#CECEDC"
      />
      <path
        d="M13.6396 30.885C13.374 30.885 13.1615 30.681 13.1084 30.426C13.0552 30.171 13.2677 29.916 13.5865 29.865L21.1302 29.1C21.3959 29.049 21.6615 29.253 21.7146 29.559C21.7677 29.814 21.5552 30.069 21.2365 30.12L13.6927 30.885H13.6396Z"
        fill="#CECEDC"
      />
      <path
        d="M21.1844 33.5881H13.6406C13.3219 33.5881 13.1094 33.3841 13.1094 33.0781C13.1094 32.7721 13.3219 32.5681 13.6406 32.5681H21.1844C21.5031 32.5681 21.7156 32.7721 21.7156 33.0781C21.7156 33.3841 21.5031 33.5881 21.1844 33.5881Z"
        fill="#CECEDC"
      />
      <path
        d="M36.2187 35.73H28.0906C27.7719 35.73 27.5594 35.526 27.5594 35.22C27.5594 34.914 27.7719 34.71 28.0906 34.71H35.6875V14.565L28.4625 12.321L21.5562 15.279V18.696C21.5562 19.002 21.3437 19.206 21.025 19.206C20.7062 19.206 20.4937 19.002 20.4937 18.696V14.922C20.4937 14.718 20.6 14.514 20.8125 14.463L28.1969 11.301C28.3031 11.25 28.4625 11.25 28.5687 11.25L36.3781 13.698C36.5906 13.8 36.75 14.004 36.75 14.208V35.22C36.75 35.526 36.5375 35.73 36.2187 35.73Z"
        fill="#CECEDC"
      />
    </g>
    <defs>
      <clipPath id="clip0_1847_114243">
        <rect
          width={34}
          height={34}
          fill="white"
          transform="translate(7 7)"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgOrganizationPlaceholder = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgOrganizationPlaceholder;
